import React, { useEffect, useState } from "react";
import { loginBack } from "helper/constant";
import loginEnhancer from "./enhancer/LoginEnhancer";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import authActions from "redux/auth/actions";
import NavigationActions from "redux/navigation/actions";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Loader from "components/Loader";
import { checkApi } from "services/authServices";
import { loginApi, resendOTP } from "services/merchantAuthServices";
import OTPModal from "./OTPModal";
import { Modal } from "reactstrap";
import svgLogo from "../../../assets/images/logo.svg";
import SideImage from "./SideImage";

const {
  success,
  error,
  fetching,
  toggleOneTimeModal,
  toggleSubscriptionLoader
} = NavigationActions;
const { login, setUser, logout } = authActions;

function Login(props) {
  const [togglePassword, setTogglePassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otpModal, setOtpModal] = useState(false);
  const [showVerificationWarning, setShowVerificationWarning] = useState(false);
  const [userEmail, setUserEmail] = useState(false);

  let closeModal = () => {
    setOtpModal(false);
  };

  const handleLogin = async e => {
    e.preventDefault();
    setShowVerificationWarning(false);
    let { values, handleSubmit, isValid, user } = props;
    handleSubmit();
    if (isValid) {
      fetching();

      setLoading(true);
      await loginApi(values).then(data => {
        console.log(data.data, "login data");
        if (data.success) {
          success(data.message);
          props.login(data.data);
          let userData = data.data;
          props.setUser(userData);
          props.history.push("/dashboard");
          console.log(userData, "userData");
          setLoading(false);
        } else {
          if (data.message === "otp_not_verified") {
            setShowVerificationWarning(true);
            setUserEmail(values.email);
            setLoading(false);
            return;
          }

          error(data.message);
          setLoading(false);
        }
      });
    }
  };

  const {
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    submitCount,
    isValid,
    token
  } = props;
  console.log("token", token);

  const loginContainer = {
    backgroundImage: `url(${loginBack})`,
    backgroundPosition: "center center",
    backgroundSize: "cover",
    position: "fixed",
    overflow: "auto",
    top: 0,
    bottom: 0
  };
  const handleAccountVerification = async () => {
    setLoading(true);
    await resendOTP({ email: userEmail }).then(res => {
      if (res.success) {
        // success(res.message)
        setLoading(false);
        setOtpModal(true);
      } else {
        error(res.message);
        setLoading(false);
      }
    });
  };
  const checkLogin = async () => {
    fetching();
    console.log("check merchant");

    await checkApi(token).then(res => {
      if (res.success) {
        success();
        console.log("here checking");
        props.setUser(res.data);
        if (res.data.is_user === false && res.data.is_superadmin === false) {
          props.history.push("/dashboard");
        } else {
          logout();
        }
      } else {
        error();
      }
    });
  };
  useEffect(() => {
    console.log("here");
    token !== null && checkLogin();
  }, []);

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };

  return (
    <div className="login-row">
      <div className="login-box">
        <div className="form-container login-form ">
          {/* <div className="login-icon">
                <img src={iconDemo} alt="icon" height="100px" />
              </div> */}
          <div className="logo">
            <img src={svgLogo} alt="" />
          </div>
          <div className="login-title">Sign in to your account</div>
          <form onSubmit={handleLogin}>
            <div className="form-group">
              {/* <label>Email</label> */}
              <input
                type="email"
                className="form-control react-form-input"
                id="email"
                onChange={handleChange}
                value={values.email}
                onBlur={handleBlur}
                placeholder="Enter email"
              />
              <Error field="email" />
            </div>

            <div className="form-group">
              {/* <label>Password</label> */}
              {/* <input
              type="password"
              className="form-control react-form-input"
              id="password"
              value={values.password}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Password"
            /> */}
              <div className="input-group show-hide-password">
                <input
                  type={togglePassword ? "text" : "password"}
                  className="form-control react-form-input"
                  id="password"
                  onChange={handleChange}
                  value={values.password}
                  onBlur={handleBlur}
                  placeholder="Enter password"
                />
                <div className="input-group-append">
                  {togglePassword ? (
                    <VisibilityOff onClick={() => setTogglePassword(false)} />
                  ) : (
                    <Visibility
                      onClick={() => {
                        setTogglePassword(true);
                        // console.log("clicked");
                      }}
                    />
                  )}
                </div>
              </div>
              <Error field="password" />
              <div className="d-flex justify-content-between">
                <div
                  className="text-right link-label"
                  onClick={() => props.history.push("/forgetPassword")}
                >
                  Forgot Password ?
                </div>
              </div>
            </div>

            {/* <div className="form-check text-center mtb-16">
            <input
              type="checkbox"
              className="form-check-input"
              id="exampleCheck1"
            />
            <label className="form-check-label" htmlFor="exampleCheck1">
              Remember me
            </label>
          </div> */}
            {/* {console.log(isValid, "isValid", values)} */}

            <button
              type="submit"
              className="btn form-button siteenterbutton mt-3"
            >
              Login
            </button>

            {showVerificationWarning ? (
              <div className="text-danger verify-warning-container mt-2">
                <span className="verify-warning mr-1">
                  Your account is not verified{" "}
                </span>
                <a
                  href="#"
                  onClick={() => handleAccountVerification()}
                  className="ml-1 verify-warning link-label"
                >
                  verify your account
                </a>{" "}
              </div>
            ) : null}

            <div className="login-or-row">
              <span>OR</span>
            </div>
            <div className="dont-have-row">
              Dont't have an account?
              <span
                className="link-label text-decoration-underline"
                onClick={() => props.history.push("/register")}
              >
                Register Now
              </span>
            </div>
          </form>
        </div>
        {loading && <Loader />}
        {otpModal && (
          <Modal isOpen={otpModal} backdrop={true} centered>
            {otpModal && (
              <OTPModal
                closeModal={closeModal}
                isResendRequest={true}
                email={userEmail}
                setWarning={() => setShowVerificationWarning(false)}
              />
            )}
          </Modal>
        )}
      </div>
      <SideImage />
      {/* <div className="login-image-div">
        <img src={loginImage} alt="icon" />
      </div> */}
    </div>
  );
}
const mapStateToProps = state => {
  return {
    token: state.auth.accessToken,
    user: state.auth.user,
    isUser: state.auth.isUser,
    isSuperAdmin: state.auth.isSuperAdmin

    // isFetching: state.navigation.isFetching
  };
};

export default compose(
  withRouter,
  loginEnhancer,
  connect(mapStateToProps, {
    // check,
    login,
    success,
    error,
    toggleOneTimeModal,
    toggleSubscriptionLoader,
    fetching,
    setUser
  })
)(Login);
